// dev
// export const apiUrl = 'https://api-standalone.esmee-dev.sourceful.pl/WebInterface.ashx'

// prod
export const apiUrl = '/WebInterface/WebInterface.ashx'

// test
// export const apiUrl = 'https://api.esmee-dev.sourceful.pl/WebInterface.ashx'
